import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';

import AccountNumberContainers from '../common/accountNumberContainers';

/*Actions*/
import {
	resetGEAccountNumbers,
	updateUserAccounts,
	getAdminEmailAddress,
	dropProductSpecsEmail,
	saveIsAnyValidAccountNumber
} from '../../../redux/actions';

import { routes } from '../../../redux/api/routes';
let { localStorageVar } = routes;

class RequestAccess extends Component {

    constructor(props){
        super(props);
        this.state = {
			localStorageVar : 'gessouserdetailscnet',
			errorMessage: '',
			isAnyValidAccountNumber: null,
			parallelCallCount: 0,
        };
    }

	componentWillMount() {
		this.props.resetGEAccountNumbers();
		var localStorageObj = this.props.getLocalStorageVar(localStorageVar);
		if(localStorageObj) {
			localStorage.removeItem(this.state.localStorageVar);
		} else {
			browserHistory.push("/login");
		}
	}

	// componentWillMount() {
	// 	window.scrollTo(0, 0);
	// 	let { approvedAccounts } = this.props.state.user;
	// 	if(!approvedAccounts || !approvedAccounts.responseObject) {
	// 	 	//redirect to sso registration page if user directly comes on this page
	// 	 	browserHistory.push("/login");
	// 	}
	// 	let { dispatch } = this.props;
	// 	dispatch(resetGEAccountNumbers());
	// }

	handleRequestAccessSubmit(event) {
		event.preventDefault();
		const self = this,
			{ registration } = self.props.state,
			{ geAccountNumbers } = registration;

		self.setState({
			parallelCallCount: _.filter(geAccountNumbers, item => item.accountNumber).length,
		}, () => {
			if(self.state.parallelCallCount === 0) {
				// Show message to enter at least one valid account number
				self.props.saveIsAnyValidAccountNumber(false);
			}
			geAccountNumbers.forEach((item, index) => {
				if(item.accountNumber) {
					self.props.validateAccountNumber(index + 1, item.accountNumber, () => {
						const parallelCallCount = self.state.parallelCallCount;
						self.setState({
							parallelCallCount: parallelCallCount - 1,
						}, () => {
							if(self.state.parallelCallCount === 0) {
								if(!_.find(geAccountNumbers, ["valid", false])) {
									//check if any valid account is passed
									const validatedAccount = _.filter(this.props.state.registration.geAccountNumbers, ["valid", true]),
										totalEnteredAccount = [];
									this.props.state.registration.geAccountNumbers.map((item, index) => {
										if(item.accountNumber !== "")
											totalEnteredAccount.push(item);
										return null;
									});

									self.setState({
										isAnyValidAccountNumber: validatedAccount.length === 0?false:true,
										errorMessage: ''
									});

									if(validatedAccount.length > 0 && validatedAccount.length === totalEnteredAccount.length) {
										var accountRequests = [];
										this.props.state.registration.geAccountNumbers.map((item, index) => {
											if(item.valid) {
												accountRequests.push({
													accountNumber: item.accountNumber,
												   	userId: self.props.state.user.userDetails.sso,
													approvalStatus: "Pending",
													accountName: item.accountName,
													admin: null,
													notifications: null,
													responsibilities: null,
													createdDate: null,
													updatedDate: null
												});
											}
											return null;
										});

										let { state } = this.props;
										//After hiding make service call of registration
										self.props.updateUserAccounts(accountRequests, 'requestType=updateAccounts', response => {
											if(response.status) {
												var accountsList = [];
												accountRequests.map((item, index) => {
													accountsList.push(item.accountNumber);
													return null;
												});
												let { userDetails } = state.user;
												self.props.getAdminEmailAddress(`requestType=getAdminsOfAccounts&accountNumbers=${accountsList.join(",")}`, response => {
													if(response.status) {
														const payload = {
														    userName: userDetails.firstName + " " + userDetails.lastName,
														    userId: userDetails.sso,
														    userEmail: userDetails.email,
														    adminDetails: response.responseObject,
														    status:"Pending"
														};
														self.props.dropProductSpecsEmail(payload, "emailType=Registration", resp => {
															if(response.status) {
																browserHistory.push("/prelogin/request-access/confirmation");
															} else {
																browserHistory.push("/prelogin/error");
															}
											            });
													} else {
														self.setState({
												 			errorMessage: response.responseMessage
												 		})
													}
												});
										 	} else {
										 		self.setState({
										 			errorMessage: response.responseMessage
										 		})
										 	}
										});
									}
								} else {
									// Show message to enter at least one valid account number
									self.props.saveIsAnyValidAccountNumber(false);
								}
							}
						})
					});
				}
			});
		});
	}

    render() {
		const { user, registration } = this.props.state,
			approvedAccounts = user.approvedAccounts,
			totalEnteredAccount = [];
		registration.geAccountNumbers.map((item, index) => {
			if(item.accountNumber !== "")
				totalEnteredAccount.push(item);
			return null;
		});
        return (
			<form onSubmit={this.handleRequestAccessSubmit.bind(this)} className={"requestAccessToCustomerNetForm "+(!this.state.showAddMoreAccountsLink?"withAdditionalAccountNumberFields":"")} name="requestAccessToCustomerNetForm" id="requestAccessToCustomerNetForm">
				<p className="red">{this.state.errorMessage}</p>
				<h1 className="pageTitle uppercase">Request Access for GE Appliances CustomerNet Accounts</h1>
				{approvedAccounts && approvedAccounts.responseObject
					?<h2 className="noMarginBottom">User Name &amp; ID: {approvedAccounts.responseObject.firstName} {approvedAccounts.responseObject.lastName} — {approvedAccounts.responseObject.userId}</h2>
					:null
				}
			  	<div className="largePush">
					<p>Enter the account number(s) you will need to access on GE Appliances CustomerNet. You may request up to 20 different accounts.<br />
					If you need access to more accounts, you will need to contact your Account Administrator.</p>
					<AccountNumberContainers acceptNumbersOnly={this.props.acceptNumbersOnly} handleAddMoreAccounts={null} showAddMoreAccountsLink={false} />
			  	</div>
				<p><input className="blueButton" type="submit" value="Submit Request" /></p>
			</form>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	updateUserAccounts: (payload, hybridQueryParams, callback) => dispatch(updateUserAccounts(payload, hybridQueryParams, callback)),
	resetGEAccountNumbers: () => dispatch(resetGEAccountNumbers()),
	getAdminEmailAddress: (data, callback) => dispatch(getAdminEmailAddress(data, callback)),
	dropProductSpecsEmail: (payload, hybridQueryParams, callback) => dispatch(dropProductSpecsEmail(payload, hybridQueryParams, callback)),
	saveIsAnyValidAccountNumber: (data) => dispatch(saveIsAnyValidAccountNumber(data)),
})

RequestAccess = connect(mapStateToProps, mapDispatchToProps)(RequestAccess);
export default RequestAccess;



// WEBPACK FOOTER //
// ./src/App/components/PreLogin/RequestAccess/index.js